import React from "react";
import { Table } from "react-bootstrap";

import "../styles/util.css";

const situacion = (valor)=>{
   
    let resultado;
    switch(valor){
      case '1' :
        resultado = "1 - Adherida y con alta"
        break;
      case '2' :
        resultado = "2 - Adherida y sin alta"
        break;
      case '3' :
        resultado = "3 - Adherida, sin alta y c/ serv. presenciales"
        break;
      case '4' :
        resultado = "4 - No Adherida y con alta";
        break;
      case '5' :
        resultado = "5 - No Adherida y sin alta";
        break;
      default:
        resultado = "-";
    }
  
    return resultado;
  }

function ListJurisdiccionSirtac({ data }) {
 
  return (
    <>
      <h1 className="mt-3 mb-3">Distribución</h1>
      <Table>
        <thead>
          <tr className="bg-blue txt-white">
            <th className="">Jurisdicción</th>
            <th className="txt-center">% de Distribución</th>
            <th className="txt-right">Situación Jurisdicción</th>
          </tr>
        </thead>
        <tbody>
          {data.padronCtribJur.map((jur, i) => {
            return (
              <tr key={i}>
                <td className="txt-grey size-10">
                  {jur.idJurisdiccion + " - " + jur.descJurisdiccion}
                </td>
                <td className="size-10 txt-grey txt-center">{jur.coeficienteRecalc}</td>
                <td className="size-10 txt-grey txt-right">{situacion(jur.cod)}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </>
  );
}

export default ListJurisdiccionSirtac;
